module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/sofa/sofa.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/sofa/sofa.png
// module id = 630
// module chunks = 0